import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initOutsourceLinkFullCards() {
  Alpine.data(
    'outsourceLinkFullCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.sw-outsourceLinkFullCards');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          loop: true,
          centeredSlides: false,
          autoplay: {
            delay: 2500,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .sw-outsourceLinkFullCards__buttons .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          spaceBetween: 25,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 30,
              centeredSlides: true,
              autoHeight: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            992: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          },
        });
      },
    }),
  );
}
